export const selectLeaves = (state) => state.companyLeaveDetails?.leaves || [];
export const selectLeaveLoading = (state) =>
  state.companyLeaveDetails?.loading || false;
export const selectLeaveError = (state) =>
  state.companyLeaveDetails?.error || null;
export const selectSelectedLeave = (state) =>
  state.companyLeaveDetails?.selectedLeave || null;
export const selectUpdatingAction = (state) =>
  state.companyLeaveDetails?.updatingAction || false;
